import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { createUrl } from '_clean-code/utils/urlHelper';
import type { ConfigData } from 'ducks/config/reducers';

export const COMPANY_UI_CONFIG_QUERY_KEY = 'company-ui-config';

/**
 * Company UI config including per-machine feature flags. V2 Production
 * Settings reads this via React Query instead of the Redux config slice.
 * Endpoint matches legacy `getCompanyUIConfig` (`GET /config/user`).
 */
export function useCompanyUIConfig() {
  return useQuery<ConfigData, Error>({
    queryKey: [COMPANY_UI_CONFIG_QUERY_KEY],
    queryFn: async () => {
      const { data } = await api.get<ConfigData>(
        createUrl('/config/user').toStringUrl()
      );
      return data;
    },
    staleTime: Infinity,
    gcTime: Infinity
  });
}
